import { NuqsAdapter } from "nuqs/adapters/react";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router";
import { Toaster } from "./components/ui/sonner";
import i18n from "./lib/i18n";
import { AppRoutes } from "./route";

export function App() {
  return (
    <BrowserRouter>
      <NuqsAdapter>
        <I18nextProvider i18n={i18n}>
          <AppRoutes />
        </I18nextProvider>
      </NuqsAdapter>
      <Toaster richColors />
    </BrowserRouter>
  );
}
